import {DataStatus, DynamicUi, FieldValues, Separator} from 'platform/components';
import {Heading, Hide} from 'platform/foundation';

import {UseFormReturn} from 'react-hook-form';

// eslint-disable-next-line no-restricted-imports -- Intended
import {path} from 'ramda';

import {NotificationSettingsResponseBody, Obligation, useGetSchemaQuery} from '@dms/api/core';
import i18n from '@dms/i18n';

import {RequiredTestIdProps, useRequiredParams} from 'shared/web';

import type {FormValues} from '../types/FormValues';

interface CustomFieldsNotificationSettingsProps extends RequiredTestIdProps {
  obligation: Obligation | undefined;
  notificationSettings: NotificationSettingsResponseBody | undefined;
  formApi: UseFormReturn<FormValues>;
}
const SCHEMA_ID = 'notification';

export function CustomFieldsNotificationSettings(props: CustomFieldsNotificationSettingsProps) {
  const {id} = useRequiredParams();
  const notificationSchemaId = `${SCHEMA_ID}-${id}`;

  const {
    data: schema,
    isLoading: isLoadingSchema,
    isError: isSchemaError,
    error,
  } = useGetSchemaQuery({id: notificationSchemaId});

  const defaultValues =
    props.notificationSettings?.tenantSettings ?? props.notificationSettings?.systemSettings;

  const handleOnChange = (values: FieldValues) => {
    props.formApi.setValue('settings', values);
  };

  const isNotFoundError = path(['status'], error) === 404;

  return (
    <Hide when={isNotFoundError || isLoadingSchema}>
      <Separator spacing={0} />

      <Heading size={4}>{i18n.t('page.settings.notifications.anotherSettings')}</Heading>

      <DataStatus minHeight={20} isError={isSchemaError}>
        {schema?.root && (
          <DynamicUi
            schema={schema.root}
            isReadOnly={props.obligation === 'system'}
            defaultValues={defaultValues}
            onChange={handleOnChange}
          />
        )}
      </DataStatus>
    </Hide>
  );
}
